import { Alert, Snackbar, SnackbarOrigin } from "@mui/material";
import { stylesGW } from "../grainWiseStylesMUIComponents";

type GrainTrackerErrorMessagesProps = {
  t: (arg0: string) => string;
  deleteBinError?: string;
};

export const ShowsMessagesError = ({
  t,
  deleteBinError,
}: GrainTrackerErrorMessagesProps) => {
  return (
    <div>
      <Snackbar
        open={!!deleteBinError}
        autoHideDuration={4000}
        anchorOrigin={
          stylesGW.ShowsMessagesSuccess.anchorOrigin as
            | SnackbarOrigin
            | undefined
        }
      >
        <Alert
          severity="error"
          variant="filled"
          sx={stylesGW.ShowsMessagesSuccess.alert}
        >
          {t("Gran_tracker_bins.delete_storage_error")}
        </Alert>
      </Snackbar>
    </div>
  );
};
